import { Link } from "@mui/material";

import { GetStaticPropsContext } from "next";
import { useTranslation } from "next-i18next";

import { useRouter } from "next/router";

import React, { ReactNode, useContext, useEffect } from "react";

import { serverSideTranslations } from "next-i18next/serverSideTranslations";

import * as ROUTES from "./_routes.json";

import I18nLink from "../../components/Atoms/I18nLink";
import Layout from "../../components/Layout";
import PageTitle from "../../components/Molecules/PageTitle";
import SEO from "../../components/Molecules/SEO";
import AlternateLangContext from "../../context/alternateLangContext/context";
import useAlternateLinkTo from "../../hooks/useAlternateLinkTo";

const ContactForm = (): ReactNode => {
    const { locale } = useRouter();
    const { t } = useTranslation("contact");

    const alternateLinks = useAlternateLinkTo("/", ROUTES, "/contact");
    const { setAlternateUrls } = useContext(AlternateLangContext);

    useEffect(() => {
        setAlternateUrls(alternateLinks);
    }, [alternateLinks, setAlternateUrls]);

    const title = t("title");
    const metaTitle = t("metaTitle");
    const metaDescription = t("metaDescription");
    const canonical = alternateLinks.find((link) => link.hrefLang === locale)?.href;

    return (
        <>
            <SEO
                title={metaTitle}
                description={metaDescription}
                openGraph={{
                    title: metaTitle,
                    // todo: add meta description field for the article
                    type: "webpage"
                }}
                // Remove current language from alternate links
                alternateLinks={alternateLinks}
                canonical={`https://carl-topham.com${canonical}`}
            />
            <PageTitle title={title} />
            <section>
                <div>
                    <div>
                        {locale === "en" ? (
                            <p>
                                Please get in touch with me via{" "}
                                <I18nLink href="https://www.linkedin.com/in/carltopham">
                                    my LinkedIn profile
                                </I18nLink>
                                .
                            </p>
                        ) : (
                            <p>
                                Merci de me contacter via{" "}
                                <Link href="https://www.linkedin.com/in/carltopham">
                                    mon profil LinkedIn
                                </Link>
                            </p>
                        )}
                    </div>
                </div>
            </section>
        </>
    );
};

ContactForm.getLayout = (page: React.ReactElement) => <Layout>{page}</Layout>;

export default ContactForm;

export async function getStaticProps(context: GetStaticPropsContext) {
    const { locale } = context;

    return {
        props: {
            ...(await serverSideTranslations(locale || "en", [
                "common",
                "contact",
                "nav"
            ]))
        }
    };
}
